import { useGetDashboardData } from "@shared/api/hooks";
import { useChartData, useOrgData, useSubscriptionData } from "../../hooks";
import { DataUploadCard } from "../cards/DataUploadCard";
import { OrganizationSetupCard } from "../cards/OrganizationSetupCard";
import { SecurityActivityCard } from "../cards/SecurityActivityCard";
import { TrialPlanCard } from "../cards/TrialPlanCard";
import { UserAdoptionCard } from "../cards/UserAdoptionCard";
import { UtilitySetupCard } from "../cards/UtilitySetupCard";

export function DashboardCards() {

  const {data: onbDashboard} = useGetDashboardData('system_admin_dashboard');

    const subscriptionData = onbDashboard?.metrics?.subscriptionPlan;
  const chartData = onbDashboard?.metrics?.userLoginAnalytics;
  const data = onbDashboard?.metrics?.tenantSetupProgress;
  const orgProgress = data?.tenantProgressPercentage ?? 0;
  const tasks = data?.tasks ?? [];
  console.log("tasks", tasks);
  const utilityProgrss = data?.overallUtilityProgress ?? 0;

  const subscriptionDetails = subscriptionData ?? [];

  // Pass the API data safely or fallback empty objects
  const activeUserDetails = chartData?.activeUserDetails ?? {};
  const todaysActiveUsers = chartData?.todaysActiveUsers ?? 0;
  const weekGrowthInPercentage = chartData?.weekGrowthInPercentage ?? 0;

  const userLoginDetails = chartData?.loginDetails ?? {};
  const totalAuthorizedCount = chartData?.totalAuthorizedCount ?? 0;
  const totalUnauthorizedCount = chartData?.totalUnauthorizedCount ?? 0;

  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        <OrganizationSetupCard progress={orgProgress} tasks={tasks} />
        <UtilitySetupCard orgSetupData={data} progress={utilityProgrss} />
        <DataUploadCard />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        <UserAdoptionCard
          activeUserDetails={activeUserDetails}
          todaysActiveUsers={todaysActiveUsers}
          weekGrowthInPercentage={weekGrowthInPercentage}
        />
        <SecurityActivityCard
          userLoginDetails={userLoginDetails}
          totalAuthorizedCount={totalAuthorizedCount}
          totalUnauthorizedCount={totalUnauthorizedCount}
        />
        <TrialPlanCard subscriptionDetails={subscriptionDetails} />
      </div>
    </div>
  );
}
